import React, { useState } from 'react';
import { PaperClipIcon } from '@heroicons/react/24/solid';

const Support = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    request: '',
    attachments: null
  });

  const [submitting, setSubmitting] = useState(false);
  const [submitError, setSubmitError] = useState(null);
  const [submitSuccess, setSubmitSuccess] = useState(false);

  const handleChange = (e) => {
    const { name, value, files } = e.target;
    if (files) {
      setFormData({ ...formData, [name]: files[0] });
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    setSubmitError(null);
    setSubmitSuccess(false);

    try {
      // Replace the endpoint URL with your actual support submission API endpoint
      const formPayload = new FormData();
      formPayload.append('name', formData.name);
      formPayload.append('email', formData.email);
      formPayload.append('request', formData.request);
      if (formData.attachments) {
        formPayload.append('attachments', formData.attachments);
      }

      const response = await fetch('/api/support', {
        method: 'POST',
        body: formPayload
      });

      if (!response.ok) {
        throw new Error('Failed to submit support request.');
      }

      setSubmitSuccess(true);
      setFormData({
        name: '',
        email: '',
        request: '',
        attachments: null
      });
    } catch (err) {
      console.error(err);
      setSubmitError(err.message);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="p-8">
      <h2 className="text-3xl font-bold mb-4">Support Request</h2>
      <form onSubmit={handleSubmit} className="max-w-lg bg-white rounded-lg border border-gray-200 p-6 space-y-4">
        {submitError && <p className="text-red-500">{submitError}</p>}
        {submitSuccess && <p className="text-green-600">Your support request has been submitted successfully!</p>}
        <div>
          <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-1">Name</label>
          <input
            type="text"
            name="name"
            value={formData.name}
            onChange={handleChange}
            required
            className="border border-gray-300 rounded-md px-3 py-2 w-full"
          />
        </div>
        <div>
          <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1">Email</label>
          <input
            type="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            required
            className="border border-gray-300 rounded-md px-3 py-2 w-full"
          />
        </div>
        <div>
          <label htmlFor="request" className="block text-sm font-medium text-gray-700 mb-1">Support Request</label>
          <textarea
            name="request"
            value={formData.request}
            onChange={handleChange}
            required
            className="border border-gray-300 rounded-md px-3 py-2 w-full h-24"
          ></textarea>
        </div>
        <div>
          <label htmlFor="attachments" className="block text-sm font-medium text-gray-700 mb-1">Attachments (optional)</label>
          <div className="flex items-center space-x-3">
            <input
              type="file"
              name="attachments"
              onChange={handleChange}
              className="border border-gray-300 rounded-md px-2 py-1"
            />
            {formData.attachments && (
              <span className="text-sm text-gray-700 flex items-center space-x-1">
                <PaperClipIcon className="h-5 w-5 text-gray-700" />
                <span>{formData.attachments.name}</span>
              </span>
            )}
          </div>
        </div>
        <div className="flex justify-end">
          {submitting ? (
            <div className="bg-yellow-500 text-black px-3 py-1 w-28 rounded-md flex items-center justify-center">
              <svg
                className="animate-spin h-5 w-5 text-black"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
              >
                <circle
                  className="opacity-25"
                  cx="12"
                  cy="12"
                  r="10"
                  stroke="currentColor"
                  strokeWidth="4"
                ></circle>
                <path
                  className="opacity-75"
                  fill="currentColor"
                  d="M4 12a8 8 0 018-8v8H4z"
                ></path>
              </svg>
            </div>
          ) : (
            <button
              type="submit"
              className="bg-yellow-500 text-black px-4 py-2 rounded-md hover:bg-yellow-600 transition duration-200"
            >
              Submit
            </button>
          )}
        </div>
      </form>
    </div>
  );
};

export default Support;
